import { Typography } from "@mui/material"
import virus from "../../assets/virus.png"

export default function Prediction({prediction}) {
    return <div className="Prediction">
        <img src={virus} alt="virus icon" />
        <Typography variant="h4">Predicted Class: {prediction}</Typography>
    </div>
}